'use client';

import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import React from 'react';
import EventNames from 'src/analytics/EventNames';
import { trackClick } from 'src/analytics/Events';
import { Button } from '@get-mosh/msh-shared';
import Heading from 'src/components/Heading/Heading';
import styles from './image-content-contained.module.scss';
import type { Content } from '@prismicio/client';
import classNames from 'classnames';
import { PrismicNextImage } from '@prismicio/next';
export type ImageContentContainedProps =
    SliceComponentProps<Content.ImageContentContainedSlice>;

const ImageContentContained = ({
    slice,
    context,
}: ImageContentContainedProps & { context: { pageType: string } }) => {
    const sectionId = slice.primary.title
        ? slice.primary.title.split(' ').join('-').toLowerCase()
        : '';

    return (
        <section
            className={classNames(
                'py-8 md:py-16',
                slice.primary.background_select
                    ? `bg-${slice.primary.background_select}`
                    : '',
            )}
            style={{
                backgroundColor: slice.primary.background || '',
            }}
        >
            <div className="container">
                <div
                    id={sectionId}
                    className={classNames(
                        styles['image-content-contained'],
                        'flex flex-wrap items-center md:flex-nowrap',
                        slice.variation === 'default'
                            ? {
                                  'flex-row md:space-x-16':
                                      slice.primary.image_position,
                                  'flex flex-col-reverse md:flex-row-reverse md:space-x-16 md:space-x-reverse':
                                      !slice.primary.image_position,
                              }
                            : 'flex-col',
                    )}
                >
                    {slice.variation === 'center' ? (
                        <div className="w-full space-y-2 md:mb-4 md:w-1/2">
                            {slice.primary.pre_heading ? (
                                <p className="p1 highlight text-blue">
                                    {slice.primary.pre_heading}
                                </p>
                            ) : null}
                            <h2>{slice.primary.title}</h2>
                        </div>
                    ) : null}
                    {slice.primary.image.url ? (
                        <PrismicNextImage
                            field={slice.primary.image}
                            width={1056}
                            height={793}
                            className={classNames(
                                'w-full rounded-2xl md:my-4 md:mt-0 md:w-1/2',
                                slice.variation == 'center'
                                    ? 'mb-4 mt-2'
                                    : 'my-8',
                            )}
                        />
                    ) : null}

                    <div className="w-full md:w-1/2">
                        <div className="mb-4 space-y-2">
                            {slice.variation === 'default' ? (
                                <>
                                    {slice.primary.pre_heading ? (
                                        <p className="p1 highlight text-blue">
                                            {slice.primary.pre_heading}
                                        </p>
                                    ) : null}
                                    <Heading level={'h2'}>
                                        {slice.primary.title}
                                    </Heading>
                                </>
                            ) : null}
                        </div>
                        <PrismicRichText field={slice.primary.description} />
                        {slice.primary.cta_path && slice.primary.cta_label ? (
                            <Button
                                text={slice.primary.cta_label}
                                as="a"
                                href={slice.primary.cta_path}
                                onClick={() => {
                                    trackClick(EventNames.BUTTON_CLICKED, {
                                        pageType: context.pageType,
                                        label: slice.primary.cta_label || '',
                                        link: slice.primary.cta_path || '',
                                        variation: slice.variation,
                                        location: slice.slice_type,
                                    });
                                }}
                                className="mt-6"
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ImageContentContained;
